/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindChildAuthDto } from '../../models/find-child-auth-dto';
import { FindChildAuthResponseDto } from '../../models/find-child-auth-response-dto';

export interface NonMemberControllerFindChildById$Params {
      body: FindChildAuthDto
}

export function nonMemberControllerFindChildById(http: HttpClient, rootUrl: string, params: NonMemberControllerFindChildById$Params, context?: HttpContext): Observable<StrictHttpResponse<FindChildAuthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, nonMemberControllerFindChildById.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindChildAuthResponseDto>;
    })
  );
}

nonMemberControllerFindChildById.PATH = '/api/non-member/auth/child';
